import React from "react";
import { Typography } from "@mui/material";
import { ProgressBarStyled } from "./project-bar.styles";
import InfoIcon from "../../../../../../components/info-icon/info-icon";
import CustomLinearBar from "../custom-linear-bar/custom-linear-bar";

const ProgressBar = ({ value, startLabel, middleLabel, endLabel, description }) => {
  const overBudgetValue = value > 200 ? 100 : value > 100 ? value - 100 : 0; // Calculate the over-budget value

  const greenValue =
    overBudgetValue === 100
      ? 0
      : overBudgetValue > 0
      ? value - overBudgetValue
      : value;

  const transparentValue = 100 - overBudgetValue - greenValue;

  return (
    <ProgressBarStyled>
      <div className="labels">
        <Typography variant="body1" className="start">
          {startLabel}
          {description && (
            <div className="description">
              <InfoIcon message={description} />
            </div>
        )}
        </Typography>
        <Typography variant="body1" className="middle">
          {middleLabel}
        </Typography>
        <Typography variant="body1" className="end">
          {endLabel}
        </Typography>
      </div>
      <CustomLinearBar
        data={{
          green: greenValue,
          red: overBudgetValue,
          transparent: transparentValue,
        }}
      />
      {/* <Box position="relative" width="100%">
        <LinearProgressStyled variant="determinate" value={cappedValue} />
        {overBudgetValue > 0 && (
          <div className="red-progress">
            <OverBudgetProgress
              variant="determinate"
              value={overBudgetValue}
              className="over-budget-bar"
              style={{ position: "absolute", top: 0, left: 0, width: "100%" }}
            />
          </div>
        )}
      </Box> */}
    </ProgressBarStyled>
  );
};

export default ProgressBar;
